
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear >
                        <a-select-option value="1">审核成功</a-select-option>
                        <a-select-option value="2">等待审核</a-select-option>
                        <a-select-option value="3">审核失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="省市">
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
                />
              </a-form-item>
            </a-col>
          </a-col>

           </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" >
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator"  >


    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="danwei" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            <a-tag color="blue">{{record.year}}年</a-tag>
            {{record.province}}{{record.city}}{{record.county}}
            <span style="color: #999">人数 {{record.membercount}}</span>
            <br/>
            上传时间 {{record.today|timeFormat}}
            <br/>
          </div>
      </span>
      <span slot="status" slot-scope="text,record">
        <a-tag v-if="record.status==1" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.status==2" color="red" >待审核</a-tag>
        <a-tag v-else-if="record.status==3">审核失败</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">查看</a>
          <a-divider type="vertical" v-if="record.cert_url" />
          <a v-if="record.cert_url" @click="downloadCert(record)">下载证书</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定审核吗?" @confirm="handleShenhe(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">审核</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="applyDelete(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>



    <a-modal
    title="操作"
    :width="1200"
    :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
    v-model="visible"
    @ok="handleOk"
>
<a-spin :spinning="saveLoading">
<a-form :form="form" >
  <a-divider>人员信息</a-divider>

  <a-table :columns="subjectColumns" :data-source="formData.member_list" :pagination="false">
    <p slot="extra_field" slot-scope="record" style="margin: 0">
    </p>
    <p slot="name" slot-scope="text,record" >
      {{record.name}} <a-tag v-show="record.code">{{record.code}}</a-tag>
      <br/>
      {{record.num}}
    </p>
    <p slot="grade" slot-scope="text,record" >
      {{record.grade_name}}<br/>
      <span v-show="record.regist_date>0">注册日期{{record.regist_date|timeFormat}}</span>
    </p>
    <template slot="action" slot-scope="text,record,index">
      <!-- <a href="javascript:;" @click="onEditUser(record)">编辑</a> -->
      <a href="javascript:;" v-show="record.cert_url" @click="downloadUserCert(record)">下载证书</a>
      <a-divider type="vertical" />
    </template>
  </a-table>
  </a-form>


</a-spin>
<template slot="footer">
<a-button key="cancel" @click="handleCancel">取消</a-button>
<a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
</template>
</a-modal>




    <a-modal
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="orderVisible"
            @ok="handleOrderOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="单位"
                      hasFeedback
              >
                {{orderFormData.danwei}}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="联系人"
                      hasFeedback
              >
                {{orderFormData.ldname}}
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="应付"
                      hasFeedback
              >
                <a-input v-model="orderFormData.pay_price" allowClear  placeholder="应付金额"/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线上实付"
                      hasFeedback
              >
                {{orderFormData.payed_price}}
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="线上支付时间"
                      hasFeedback
              >
                {{orderFormData.pay_time_str}}
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
          <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="支付状态"
                      hasFeedback
              >
                <a-radio-group v-model="orderFormData.status" button-style="solid">
                  <a-radio-button :value="1">
                    未支付
                  </a-radio-button>
                  <a-radio-button :value="2">
                    支付成功
                  </a-radio-button>
                </a-radio-group>

              </a-form-item>
            </a-col>
          </a-row>

          <a-col :md="48" :sm="24">
            <a-form-item
                    :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                    :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                    label="支付方式"
                    hasFeedback
            >
              {{orderFormData.pay_type_name}}
            </a-form-item>
          </a-col>
          </a-row>


          <a-row>
            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="管理员备注"
                      hasFeedback
              >
                <a-textarea v-model="orderFormData.adminnote" placeholder="" auto-size />
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleOrderCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOrderOk">保存</a-button>
      </template>
    </a-modal>



    <a-modal
            title="人员操作"
            :width="1000"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="userFormVisible"
            @ok="handleUserFormOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form3" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="姓名"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入姓名' }]}
            ]"
                          placeholder="请输入姓名"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="身份证"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'num',
              {rules: [{ required: true, message: '请输入身份证' }]}
            ]"
                          placeholder="请输入身份证"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="性别"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'sex',
              {rules: [{ required: true, message: '请输入性别' }]}
            ]"
                          placeholder="请输入性别"/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="手机"
                      hasFeedback
              >
                <a-input  v-decorator="[
              'phone',
              {rules: [{ required: true, message: '请输入手机' }]}
            ]"
                          placeholder="请输入手机"/>
              </a-form-item>
            </a-col>
          </a-row>



          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="服务套餐"
                      hasFeedback
              >

                <a-select
                        showSearch
                        optionFilterProp="title"
                        v-model="userFormData.service_id"
                        placeholder="选择服务套餐"
                        allowClear
                >
                  <a-select-option v-for="(option,index) in serviceTypeOptions" :value="option.id">{{option.name}}</a-select-option>

                </a-select>

              </a-form-item>
            </a-col>

          </a-row>


          <a-divider>申报信息</a-divider>



          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="已有裁判等级（舞蹈）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.jiaoliandengjiwudao"
                          placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报裁判等级（舞蹈）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.jiaolianshenbaowudao"
                          placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="已有裁判等级（技巧）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.jiaoliandengjijiqiao"
                          placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报裁判等级（技巧）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.jiaolianshenbaojiqiao"
                          placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="已有教练等级（舞蹈）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.jiaoliandengjiwudao"
                        placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报教练等级（舞蹈）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.jiaolianshenbaowudao"
                        placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="已有教练等级（技巧）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.jiaoliandengjijiqiao"
                        placeholder=""/>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="申报教练等级（技巧）"
                      hasFeedback
              >
                <a-input
                        v-model="userFormData.jiaolianshenbaojiqiao"
                        placeholder=""/>
              </a-form-item>
            </a-col>
          </a-row>


        </a-form>
        </a-spin>

      <template slot="footer">
        <a-button key="cancel" @click="handleUserFormCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleUserFormOk">保存</a-button>
      </template>
      </a-modal>
      <a-modal
      :maskClosable="false"
        :footer="null"
        title="批量生成"
        v-model="taskInfoShow"
    >
        <a-badge status="success" :text="'生成成功 '+(taskInfo.scount)"/>
        <a-divider type="vertical"/>
        <a-badge status="error" :text="'生成失败 '+(taskInfo.fcount)"/>
        <a-divider type="vertical"/>
        <a-badge status="processing" :text="'总数 '+(taskInfo.urls.length-1) "/>
      </p>
        <a-progress :percent="taskInfo.percent"/>
      </p>
    </a-modal>

  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import JiaolianPicker from '@/components/JiaolianPicker/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import qs from 'qs'
  import setting from '@/config/setting'
  import XLSX from 'xlsx'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getApplyList ,getShengShenheUrls,checkShengMemberOK,shengjlApply,getShengApplyDetail,getServiceTypeList,editShengApply ,applyDelete ,sjsqOptions ,getApplyOrderDetail ,editApplyOrder,getApplyUserDetail,editApplyUser,shengApplyDelete} from '@/api/jiaolian'
  import {doUrlTask} from '@/api/utils'
  export default {
    name: 'KaojiApplyList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
      JiaolianPicker,
      JiaolianPicker,
    },
    data () {
      return {
        areaOptions,
        taskInfoShow: false,
        visible: false,
        orderVisible: false,
        saveLoading:false,
        userFormVisible:false,
        jiaolianPickerShow:false,
        jiaolianPickerShow:false,
        sjsqOptions:[],
        orderFormData:{
        },
        taskInfo: {
          urls: [],
          errors: [],
          currentIndex: 0,
          scount: 0,
          fcount: 0,
          percent: 0,
          doing: false,
        },
        formData:{
          id:0,
          danwei:'',
          areas:[],
          member_list:[],
          loglist:[],
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        form3: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
          sjsq:[]
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '报名信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '状态',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 300,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 表头
        subjectColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '姓名',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '电话',
            dataIndex: 'phone',
          },
          {
            title: '微信',
            dataIndex: 'weixin',
          },
          {
            title: '等级',
            dataIndex: 'grade',
            scopedSlots: { customRender: 'grade' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 120,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getApplyList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        },
        serviceTypeOptions:[],
        userFormData:{
          id:0,
          name:'',
          "jiaoliandengjiwudao":"",
          "jiaoliandengjijiqiao":"",
          "jiaoliandengjiwudao":"",
          "jiaoliandengjijiqiao":"",
          "jiaolianshenbaowudao":"",
          "jiaolianshenbaojiqiao":"",
          "jiaolianshenbaowudao":"",
          "jiaolianshenbaojiqiao":"",
        }
      }
    },
    computed:{
    },

    created(){
    },

    mounted(){
      let that = this;

      let query  = this.$route.query;
      // 6, 276
      console.log(query)
      if(query.saiji) {
        this.queryParam.sjsq = [query.saiji, query.saiqu]
      }
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions(){
        let that = this;
        sjsqOptions({}).then(res =>{
          that.sjsqOptions = res.data;
        });
      },
      handleCancel(){
        this.visible = false
      },
      handleOrderCancel(){
        this.orderVisible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },



      handleEdit(record){
        let self = this
        this.visible = true
        getShengApplyDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
      handleOrderEdit(record){
        let self = this
        getApplyOrderDetail({ baoming_id: record.id }).then(res => {
          self.orderVisible = true
          setTimeout(() =>{
            self.orderFormData.id = record.id;
            console.log('handleEdit')

            self.orderFormData = { ...res.data };
          },200)
        }).catch(err =>{
          self.$message.error(err.data.msg);
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

      // 增改 处理
      handleOk(e) {
        let self = this;
              self.visible = false;
              return true;
        e.preventDefault()
        if(self.formData.areas.length!=3){
          self.$message.error('请选择完整地区');
          return ;
        }
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            editShengApply({
              id:self.formData.id,
              danwei:self.formData.danwei,
              ldname:self.formData.ldname,
              weixin:self.formData.weixin,
              email:self.formData.email,
              phone:self.formData.phone,
              fapiao_taitou:self.formData.fapiao_taitou,
              fapiao_shuihao:self.formData.fapiao_shuihao,
              fapiao_beizhu:self.formData.fapiao_beizhu,
              fapiao_email:self.formData.fapiao_email,
              fapiao_phone:self.formData.fapiao_phone,
              memberstatus:self.formData.memberstatus,
              area:self.formData.areas[self.formData.areas.length-1],
              address:self.formData.address,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },
      // 增改 处理
      handleOrderOk(e) {
        let self = this;
        e.preventDefault();

        self.saveLoading = true;
        editApplyOrder({
          id:self.orderFormData.id,
          baoming_id:self.orderFormData.baoming_id,
          status:self.orderFormData.status,
          adminnote:self.orderFormData.adminnote,
          memberprice:self.orderFormData.memberprice,
          pay_price:self.orderFormData.pay_price,
        }).then(res => {
          self.$message.success('修改成功')
          self.$refs.table.refresh(false)
          self.orderVisible = false;
          self.saveLoading = false;
        }).catch(err =>{
          self.$message.error(err.data.msg);
          self.saveLoading = false;
        })
      },

      // 删
      applyDelete(record) {
        let self = this
        shengApplyDelete({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      // 删
      applyDeleteAll() {
        let self = this
        applyDelete({ ids: self.selectedRowKeys ,id:0 }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh()
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },


      onEditUser(record){
        let self = this
        this.userFormVisible = true
        getApplyUserDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form3.setFieldsValue({ ...res.data })
            self.userFormData.id = record.id;
            self.userFormData = { ...res.data };
          },200)
        });
        getServiceTypeList({ saiqu: self.formData.saiqu }).then(res => {
          setTimeout(() =>{
            self.serviceTypeOptions = res.data
          },200)
        });
      },
      handleUserFormCancel(){
        this.userFormVisible = false
      },


      handleUserFormOk(e) {
        let self = this;
        e.preventDefault()
        this.form3.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.userFormData)
            self.saveLoading = true;
            editApplyUser({
              id:self.userFormData.id,
              name:values.name,
              num:values.num,
              phone:values.phone,
              sex:values.sex,
              service_id:self.userFormData.service_id,
              jiaoliandengjiwudao:self.userFormData.jiaoliandengjiwudao,
              jiaoliandengjijiqiao:self.userFormData.jiaoliandengjijiqiao,
              jiaoliandengjiwudao:self.userFormData.jiaoliandengjiwudao,
              jiaoliandengjijiqiao:self.userFormData.jiaoliandengjijiqiao,
              jiaolianshenbaowudao:self.userFormData.jiaolianshenbaowudao,
              jiaolianshenbaojiqiao:self.userFormData.jiaolianshenbaojiqiao,
              jiaolianshenbaowudao:self.userFormData.jiaolianshenbaowudao,
              jiaolianshenbaojiqiao:self.userFormData.jiaolianshenbaojiqiao,
            }).then(res => {
              self.$message.success('修改成功')
              self.userFormVisible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })

          }
        })
      },


      download(type){
        console.log('this.queryParam')
        console.log(this.queryParam)
        if(typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length !=2){
          this.$message.error('请先选择赛区');
          return ;
        }
        switch (type){
          case 1:
            window.open(setting.apiBaseURL+'/adminapi/huiyi/applyDownload?saiqu='+qs.stringify(this.queryParam));
            break;
          case 2:
            window.open(setting.apiBaseURL+'/adminapi/huiyi/memberDownload?saiqu='+qs.stringify(this.queryParam));
            break;
          case 3:
            window.open(setting.apiBaseURL+'/adminapi/sai/rysfzDownload?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 4:
            window.open(setting.apiBaseURL+'/adminapi/sai/csrstjDownload?saiqu='+this.queryParam.sjsq[1]);
            break;
          case 5:
            window.open(setting.apiBaseURL+'/adminapi/sai/zhixuceDownload?saiqu='+this.queryParam.sjsq[1]+'&memberstatus='+(this.queryParam.memberstatus||0));
            break;
          case 6:
            window.open(setting.apiBaseURL+'/adminapi/sai/caiwuDownload?saiqu='+this.queryParam.sjsq[1]);
            break;

        }
      },



    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      handleShenhe(record){
        let that = this;
        this.taskInfoShow = true
        getShengShenheUrls({
          id:record.id
        }).then(res => {
          that.taskInfo = {
            urls: res.data,
            currentIndex: 0,
            scount: 0,
            fcount: 0,
            doing: true,
          }
          that.doTask(that.taskInfo);

        }).catch(err => {
          that.$message.error(err.data.msg);
        })
      },
      doTask(taskInfo) {
        let that = this;
        if (taskInfo.currentIndex >= taskInfo.urls.length) {
          taskInfo.doing = false;
          that.taskInfoShow = false;
          that.$refs.table.refresh()
          return false;
        }
        doUrlTask({
          url: taskInfo.urls[taskInfo.currentIndex]
        }).then(res => {
          taskInfo.scount++;
          taskInfo.currentIndex++;
          console.log(taskInfo.currentIndex);
          if (taskInfo.currentIndex == (taskInfo.urls.length)) {

          }
          taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.urls.length) * 100).toFixed(1);
          that.doTask(taskInfo)
        }).catch(err => {
          taskInfo.fcount++;
          taskInfo.currentIndex++;
          taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.urls.length) * 100).toFixed(1);
          that.doTask(taskInfo)
        });
      },
    downloadCert(record){
      window.open(setting.apiBaseURL+''+record.cert_url)
    },
    downloadUserCert(record){
      window.open(setting.apiBaseURL+''+record.cert_url)
    },

    },
    filters:{
    },
    watch: {
    }
  }
</script>
